(function() {
  var BaseHandler, BaseOutput, ChartOutput,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  BaseHandler = App.loadClass("core::reports/BaseHandler");

  BaseOutput = App.loadClass("core::reports/BaseOutput");

  ChartOutput = App.loadClass("core::reports/ChartOutput");

  exports.ReportsNPracticesSubHandler = (function(superClass) {
    extend(ReportsNPracticesSubHandler, superClass);

    function ReportsNPracticesSubHandler() {
      this.getDataDetail = bind(this.getDataDetail, this);
      return ReportsNPracticesSubHandler.__super__.constructor.apply(this, arguments);
    }

    ReportsNPracticesSubHandler.prototype.init = function() {
      this.hasPrint = false;
      this.parent.dialog.find('.print-btn').hide();
      this.sourceUrl = 'backend/grower/reports/n-practices/output/detail';
      this.layoutUrl = 'backend/grower/reports/n-practices/chart';
      this.filterUrl = 'backend/grower/reports/n-practices/filters';
      this.layoutSelector = "#reports_n_practices_tab";
      $('.sidebar_content').find('.view-field-group-button-container').removeClass('hide');
      $('.sidebar_content').find('#view-field-group-button').prop('disabled', true);
      this.parent.dialog.find('.npractices-label').removeClass('hide');
      this.parent.dialog.find('.npractices-label').clickover({
        html: true,
        container: '#bs2-container'
      });
      this.initFilters();
      this.borderWidth = 2;
      this.hoverBorderWidth = 3;
      return this.fieldGroup = null;
    };

    ReportsNPracticesSubHandler.prototype.afterLoadLayout = function() {
      return ReportsNPracticesSubHandler.__super__.afterLoadLayout.call(this);
    };

    ReportsNPracticesSubHandler.prototype.initFilters = function() {
      this.disableAllFilterGroups();
      this.parent.filters.importGroup({
        name: 'N Practices Report Filters',
        display_name: 'Report Filters',
        filters: [
          {
            name: 'report_type',
            display_name: 'Report Type',
            control_type: 'option',
            deletable: false,
            values: [
              {
                key: 'nbalance',
                value: 'N Balance'
              }, {
                key: 'yield',
                value: 'Yield'
              }
            ],
            selected_values: [
              {
                key: 'nbalance',
                value: 'N Balance'
              }
            ]
          }, {
            name: 'npractice_years',
            display_name: 'Year',
            control_type: 'dropdown'
          }, {
            name: 'crops',
            display_name: 'Crop',
            control_type: 'single_dropdown',
            auto_select_first: true
          }, {
            name: 'previous_crops',
            display_name: 'Previous Crop',
            control_type: 'dropdown'
          }, {
            name: 'max_distance',
            display_name: 'Distance',
            control_type: 'single_dropdown',
            values: [
              {
                key: '50',
                value: 'Within 50 miles'
              }, {
                key: '100',
                value: 'Within 100 miles'
              }, {
                key: '150',
                value: 'Within 150 miles'
              }, {
                key: '200',
                value: 'Within 200 miles'
              }, {
                key: '250',
                value: 'Within 250 miles'
              }, {
                key: '300',
                value: 'Within 300 miles'
              }, {
                key: '350',
                value: 'Within 350 miles'
              }
            ]
          }, {
            name: 'npractice_operation_sizes',
            display_name: 'Operation Size',
            control_type: 'dropdown'
          }, {
            name: 'partners',
            display_name: 'Partner',
            control_type: 'dropdown'
          }, {
            name: 'npractice_fields',
            display_name: 'Field',
            control_type: 'dropdown'
          }, {
            name: 'npractice_field_groups',
            display_name: 'Field Group',
            control_type: 'single_dropdown',
            deletable: false,
            auto_select_by_default_flag: true,
            auto_select_only_value: true,
            auto_clear_unavailable: true
          }, {
            name: 'irrigation_type',
            display_name: 'Irrigation Type',
            control_type: 'option',
            deletable: true,
            values: [
              {
                key: 'dryland',
                value: 'Dryland'
              }, {
                key: 'irrigated',
                value: 'Irrigated'
              }
            ]
          }, {
            name: 'practices',
            display_name: 'Practice',
            control_type: 'dropdown'
          }, {
            name: 'tillage_systems',
            display_name: 'Tillage System',
            control_type: 'dropdown'
          }, {
            name: 'nitrogen_rates',
            display_name: 'Nitrogen Rate',
            control_type: 'dropdown',
            values: [
              {
                key: '0-50',
                value: '0 - 50 lbs/ac'
              }, {
                key: '50-100',
                value: '50 - 100 lbs/ac'
              }, {
                key: '100-150',
                value: '100 - 150 lbs/ac'
              }, {
                key: '150-200',
                value: '150 - 200 lbs/ac'
              }, {
                key: '200-250',
                value: '200 - 250 lbs/ac'
              }, {
                key: '250-300',
                value: '250 - 300 lbs/ac'
              }, {
                key: '300-350',
                value: '300 - 350 lbs/ac'
              }
            ]
          }, {
            name: 'primary_nitrogen_sources',
            display_name: 'Primary N Source',
            control_type: 'dropdown'
          }, {
            name: 'data_type',
            display_name: 'Mode',
            control_type: 'option',
            deletable: false,
            values: [
              {
                key: 'live',
                value: 'My Fields'
              }, {
                key: 'demo',
                value: 'Demo'
              }
            ],
            selected_values: [
              {
                key: 'live',
                value: 'My Fields'
              }
            ]
          }
        ]
      });
      return this.setDefaultsAndRun(0, 0, 0, {}, 'up', false);
    };

    ReportsNPracticesSubHandler.prototype.destroy = function() {
      this.parent.filters.removeGroup('N Practices Report Filters');
      this.parent.filters.enableGroup("Report Filters");
      this.parent.dialog.find('.excel-btn').addClass('hidden');
      this.parent.dialog.find('.info-popover').addClass('hide');
      $('.sidebar_content').find('.view-field-group-button-container').addClass('hide');
      return ReportsNPracticesSubHandler.__super__.destroy.call(this);
    };

    ReportsNPracticesSubHandler.prototype.getDataDetail = function() {
      var reportType;
      reportType = this.parent.filters.jsonize().filters.report_type[0].key === 'nbalance' ? 'N Balance' : 'Yield';
      $('.sidebar_content').find('#view-field-group-button').prop('disabled', true);
      $('.sidebar_content').find('#view-field-group-button-spinner').removeClass('hide');
      return $.get('backend/grower/reports/n-practices/output/detail', {
        query: this.filters
      }).then((function(_this) {
        return function(data) {
          var acres, datasets, labels, records, result, scores;
          $('.sidebar_content').find('#view-field-group-button-spinner').addClass('hide');
          if (data.status === 'skip') {
            return;
          }
          if (data.status === 'error') {
            _this.parent.msg.message_writer(data.status, data.message + " This report will answer more questions as more farmers participate, so please invite those you know to join for free by calling 260-693-7671.  Thanks in advance!");
            return;
          }
          result = data.reportData;
          data.fieldGroup.field_group = _this.parent.filters.jsonize().filters.npractice_field_groups[0].value;
          _this.fieldGroup = data.fieldGroup;
          $('.sidebar_content').find('#view-field-group-button').prop('disabled', false);
          records = _.orderBy(result, 'difference', 'desc');
          labels = _.map(records, 'practice');
          scores = _.map(records, 'difference');
          acres = _.map(records, 'acres');
          datasets = [
            {
              label: reportType,
              data: scores,
              fill: false,
              backgroundColor: '#498fbf',
              borderColor: '#498fbf',
              borderWidth: _this.borderWidth,
              hoverBorderWidth: _this.hoverBorderWidth
            }, {
              label: 'Acres',
              data: acres,
              hidden: true
            }
          ];
          return {
            data: {
              labels: labels,
              datasets: datasets
            },
            options: {
              legend: {
                display: false
              }
            }
          };
        };
      })(this));
    };

    ReportsNPracticesSubHandler.prototype.beforeApply = function() {
      var filters, ref, reportType, xAxes, yAxes;
      filters = this.parent.filters.jsonize();
      reportType = (ref = this.parent.filters.jsonize().filters.report_type) != null ? ref[0].key : void 0;
      if (!((this.currentOutput != null) && reportType === this.reportType)) {
        xAxes = [
          {
            scaleLabel: {
              display: true,
              labelString: reportType === 'nbalance' ? 'N Balance Change due to each Practice (N lbs/ac)' : 'Yield Gain due to each Practice (bu/ac)',
              fontSize: 20
            },
            ticks: {
              beginAtZero: true
            }
          }
        ];
        yAxes = [
          {
            scaleLabel: {
              display: false
            },
            maxBarThickness: 50
          }
        ];
        this.currentOutput = new ChartOutput(this, this.parent, this.sourceUrl, 'horizontalBar', xAxes, yAxes, {
          tooltips: {
            callbacks: {
              title: (function(_this) {
                return function(items, data) {
                  return items[0].yLabel + ' (' + data.datasets[1].data[data.labels.indexOf(items[0].yLabel)] + ' ac)';
                };
              })(this)
            }
          }
        }, this.getDataDetail);
        return this.reportType = reportType;
      }
    };

    return ReportsNPracticesSubHandler;

  })(BaseHandler);

}).call(this);
